// TODO CARD-6279: Remove when Subnav is configured in WP
export const ORGANIC_SLUG_COPIES = [
  // this is bcc slug
  undefined,
  '2-percent-cash-back',
  'airline',
  'bad-credit',
  'balance-transfer',
  'bonus-offers',
  'cash-back',
  'college-student',
  'fair-credit',
  'gas',
  'groceries',
  'hotel',
  'international-travel',
  'low-interest',
  'mastercard-cards',
  'no-annual-fee-travel',
  'no-annual-fee',
  'no-credit',
  'no-foreign-transaction-fee',
  'online-shopping',
  'restaurants',
  'rewards',
  'secured',
  'streaming-services',
  'travel',
  'visa-cards',
  'zero-percent',
] as const;
